export default "__VITE_ASSET__DZy9EE4P__"